<template lang="pug">
  .nav
    .mobile-menu
      .mobile-drawer(@click="mobileMenu = !mobileMenu")
        menu-icon

    .mobile-collapse(v-if='mobileMenu', @click="mobileMenu = false")
      span.mobile-close &#10005;

    nav(:class="{ mobile: mobileMenu }")
      ul.main-width
        li.mobile.mobile-login(v-if="!user"): router-link(to="/login/") Existing user? Sign In
        li.mobile.mobile-register(v-if="!user"): a(href="//raid-gaming.net/register/") Sign Up
        li.mobile.mobile-logout(v-if="user"): router-link(to="/logout/") Sign Out
        li.mobile(v-if="user")
          router-link(v-if="user.b3Cid",
            :to="{ name: 'client', params: { id: user.b3Cid } }", title="View Profile")
            p Profile
          a(v-else, :href="'https://raid-gaming.net/profile/' + user.id + '-' + user.seoName + '/edit/'")
            p Profile
        li: a(href="//raid-gaming.net/portal/") Portal
        li: a(href="//raid-gaming.net") Forums
        li: router-link.active(to="/") Servers
        ul.mobile-sub-menu
          li: router-link(to="/", exact) Servers
          li: router-link(to="/clients/") Clients
          li: router-link(to="/chatlogs/cod4?server=dr") Chatlogs (CoD4)
          li: router-link(to="/chatlogs/csgo?server=1") Chatlogs (CS:GO)
          li: router-link(to="/bans/") Bans (CoD4)
          li: a(href="https://sourcebans.raid-gaming.net/index.php?p=banlist", target="_blank") Bans (CS:GO)
        li: a(href="//raid-gaming.net/staff/") Staff
        li: a(href="//docs.raid-gaming.net") Script Docs
        li: a(href="//raid-gaming.net/chatbox/") Chatbox
        li: a(href="//raid-gaming.net/support/") Support
        li: a(href="//raid-gaming.net/donate/") Donate
        li.login.right(v-if="!user"): router-link(to="/login/") Sign In
        li.register(v-if="!user"): a(href="//raid-gaming.net/register/") Sign Up
        li.avatar.right(v-if="user")
          router-link(v-if="user.b3Cid", :to="{ name: 'client', params: { id: user.b3Cid } }", title="View Profile")
            img(:src="user.avatar")
            p {{ user.name }}
          a(v-else, :href="'https://raid-gaming.net/profile/' + user.id + '-' + user.seoName + '/edit/'")
            img(:src="user.avatar")
            p {{ user.name }}
        li.logout(v-if="user"): router-link(to="/logout/") Sign Out
    nav.sub-menu(:class="{ mobile: mobileMenu }")
      ul.main-width
        li: router-link(to="/", exact) Servers
        li: router-link(to="/clients/") Clients
        li: router-link(to="/chatlogs/cod4?server=dr") Chatlogs (CoD4)
        li: router-link(to="/chatlogs/csgo?server=1") Chatlogs (CS:GO)
        li: router-link(to="/bans/") Bans (CoD4)
        li: a(href="https://sourcebans.raid-gaming.net/index.php?p=banlist", target="_blank") Bans (CS:GO)
</template>

<script>
import MenuIcon from 'vue-material-design-icons/Menu.vue';

export default {
  name: 'NavBar',
  components: {
    MenuIcon,
  },
  data() {
    return {
      mobileMenu: false,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/style/definitions';

nav {
  width: 100%;
  background: $color-navbar-bg;

  @media screen and (max-width: 979px) {
    display: none;

    &.mobile {
      display: block;
      position: fixed;
      z-index: 1500;
      top: 0;
      right: 0;
      width: 280px;
      height: 100vh;
      background: $drawer-color;

      ul {
        flex-direction: column;

        li {
          a {
            font-size: 13px;
            padding: 10px 15px;
            border-bottom: 1px solid #000;
            border-top: 1px solid rgba(255, 255, 255, .05);
          }

          &.login, &.register, &.avatar, &.logout {
            display: none;
          }

          &.mobile-login, &.mobile-register, &.mobile-logout {
            a {
              border: none;
              text-align: center;
              border-radius: 4px;
              margin: 16px;
            }
          }

          &.mobile-login a, &.mobile-logout a {
            background: $drawer-accent2-bg;
            color: $drawer-accent2-fg;
          }

          &.mobile-login a {
            margin-bottom: 8px;
          }

          &.mobile-register a {
            background: $color-accent;
            margin-top: 8px;
          }

          &.right {
            margin-left: 0;
          }
        }

        ul.mobile-sub-menu {
          display: block;
        }
      }
    }
  }

  ul {
    display: flex;
    list-style: none;

    li {
      &.right {
        margin-left: auto;
      }

      a {
        display: block;
        padding: 18px;
        color: $color-navbar-fg;
        font-size: 15px;
        text-decoration: none;

        &:hover, &:focus {
          background: rgba(255, 255, 255, .04);
        }

        &.active {
          background: rgba(255, 255, 255, .08);
        }
      }

      &.avatar {
        a {
          padding: 9px;
          display: flex;
        }

        p {
          padding: 9px;
        }

        img {
          display: block;
          width: 36px;
          height: 36px;
        }
      }
    }

    ul.mobile-sub-menu {
      display: none;
      background: rgba(255, 255, 255, .14);

      li a {
        padding-left: 32px;
      }
    }
  }

  &.sub-menu {
    background: $color-navbar-sub;

    &.mobile {
      display: none;
    }

    ul {
      li a {
        padding: 12px;
        font-size: 14px;
        color: $drawer-accent2-bg;

        &.router-link-active {
          background: rgba(255, 255, 255, .08);
        }
      }
    }
  }
}

.mobile-menu {
  display: none;

  @media screen and (max-width: 979px) {
    display: block;
    position: absolute;
    top: -60px;
    left: 0;
    width: 100%;
    background: #3c3c3c;
    display: flex;

    .mobile-drawer {
      cursor: pointer;
      margin-left: auto;
      padding: 18px;

      &:hover, &:focus {
        background: rgba(255, 255, 255, .04);
      }

      svg {
        fill: $color-fg;
        width: 32px;
        height: 32px;
        margin: -7px -9px -11px -7px;
      }
    }
  }
}

.mobile-collapse {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 1200;

  span.mobile-close {
    position: fixed;
    top: 8px;
    right: 288px;
    background: $drawer-color;
    height: 40px;
    width: 40px;
    border-radius: 50%;
    text-align: center;
    line-height: 40px;
    font-weight: bold;
    font-family: arial, sans-serif;
    font-size: 14px;
    cursor: pointer;

    &:hover, &:focus {
      color: $color-accent;
    }
  }
}
</style>
